/* eslint-disable import/no-named-as-default-member */
/* User sagas */

import { call, put, takeLatest } from "redux-saga/effects"

import ErrorsActions from "../../../Redux/ErrorsRedux"
import { apiGeneratorBase, apiGeneratorDelete } from "../../../Utils/saga"
import PublicApiActions, { PublicApiTypes as constants } from "./reducer"
import * as services from "./services"

function* getApiKeysSaga(action) {
  const params = action.payload
  const response = yield call(services.getApiKeysList, params)
  if (!response.ok) {
    yield put(PublicApiActions.getApiKeysFailure(response))
    yield put(ErrorsActions.errorSave(response.data))
    return
  }
  yield put(PublicApiActions.getApiKeysSuccess(response.data))
}

function* generateApiKeySaga(action) {
  const params = action.payload
  const response = yield call(services.generateApiKey, params)
  if (!response.ok) {
    yield put(PublicApiActions.generateApiKeyFailure(response))
    yield put(ErrorsActions.errorSave(response.data))
    return
  }
  yield put(PublicApiActions.generateApiKeySuccess(response.data))
  yield put(PublicApiActions.getApiKeysRequest())
}

function* regenerateApiKeySaga(action) {
  const params = action.payload
  const response = yield call(services.regenerateApiKey, params)
  if (!response.ok) {
    yield put(PublicApiActions.regenerateApiKeyFailure(response))
    yield put(ErrorsActions.errorSave(response.data))
    return
  }
  yield put(PublicApiActions.regenerateApiKeySuccess(response.data))
  yield put(PublicApiActions.getApiKeysRequest())
}

const actions = {
  addTypesActions: {
    request: PublicApiActions.addTypesRequest,
    success: PublicApiActions.addTypesSuccess,
    errors: PublicApiActions.addTypesFailure
  },
  getEndpointsActions: {
    request: PublicApiActions.getEndpointsRequest,
    success: PublicApiActions.getEndpointsSuccess,
    errors: PublicApiActions.getEndpointsFailure
  },
  getEndpointActions: {
    request: PublicApiActions.getEndpointRequest,
    success: PublicApiActions.getEndpointSuccess,
    errors: PublicApiActions.getEndpointFailure
  },
  changeEndpointStatusActions: {
    request: PublicApiActions.changeEndpointStatusRequest,
    success: PublicApiActions.changeEndpointStatusSuccess,
    errors: PublicApiActions.changeEndpointStatusFailure
  },
  deleteEndpointActions: {
    request: PublicApiActions.deleteEndpointRequest,
    success: PublicApiActions.deleteEndpointSuccess,
    errors: PublicApiActions.deleteEndpointFailure
  },
  addEndpointActions: {
    request: PublicApiActions.addEndpointRequest,
    success: PublicApiActions.addEndpointSuccess,
    errors: PublicApiActions.addEndpointFailure
  },
  getEventsActions: {
    request: PublicApiActions.getEventsRequest,
    success: PublicApiActions.getEventsSuccess,
    errors: PublicApiActions.getEventsFailure
  },
  getEventActions: {
    request: PublicApiActions.getEventRequest,
    success: PublicApiActions.getEventSuccess,
    errors: PublicApiActions.getEventFailure
  },
  resendEventActions: {
    request: PublicApiActions.resendEventRequest,
    success: PublicApiActions.resendEventSuccess,
    errors: PublicApiActions.resendEventFailure
  }
}

const eventsOptions = {
  [constants.ADD_TYPES_REQUEST]: {
    api: services.addTypes,
    actions: actions.addTypesActions
  },
  [constants.GET_ENDPOINTS_REQUEST]: {
    api: services.getEndpoints,
    actions: actions.getEndpointsActions
  },
  [constants.GET_ENDPOINT_REQUEST]: {
    api: services.getEndpoint,
    actions: actions.getEndpointActions
  },
  [constants.CHANGE_ENDPOINT_STATUS_REQUEST]: {
    api: services.changeEndpointStatus,
    actions: actions.changeEndpointStatusActions
  },
  [constants.DELETE_ENDPOINT_REQUEST]: {
    api: services.deleteEndpoint,
    actions: actions.deleteEndpointActions
  },
  [constants.ADD_ENDPOINT_REQUEST]: {
    api: services.addEndpoint,
    actions: actions.addEndpointActions
  },
  [constants.GET_EVENTS_REQUEST]: {
    api: services.getEvents,
    actions: actions.getEventsActions
  },
  [constants.GET_EVENT_REQUEST]: {
    api: services.getEvent,
    actions: actions.getEventActions
  },
  [constants.RESEND_EVENT_REQUEST]: {
    api: services.resendEvent,
    actions: actions.resendEventActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_API_KEYS_REQUEST, getApiKeysSaga)
  yield takeLatest(constants.GENERATE_API_KEY_REQUEST, (action) => generateApiKeySaga(action))
  yield takeLatest(constants.REGENERATE_API_KEY_REQUEST, (action) => regenerateApiKeySaga(action))
  yield takeLatest(constants.ADD_TYPES_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.ADD_TYPES_REQUEST])
  )
  yield takeLatest(constants.GET_ENDPOINTS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ENDPOINTS_REQUEST])
  )
  yield takeLatest(constants.GET_ENDPOINT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ENDPOINT_REQUEST])
  )
  yield takeLatest(constants.ADD_ENDPOINT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.ADD_ENDPOINT_REQUEST])
  )
  yield takeLatest(constants.CHANGE_ENDPOINT_STATUS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.CHANGE_ENDPOINT_STATUS_REQUEST])
  )
  yield takeLatest(constants.DELETE_ENDPOINT_REQUEST, (action) =>
    apiGeneratorDelete(action, eventsOptions[constants.DELETE_ENDPOINT_REQUEST])
  )
  yield takeLatest(constants.GET_EVENTS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_EVENTS_REQUEST])
  )
  yield takeLatest(constants.GET_EVENT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_EVENT_REQUEST])
  )
  yield takeLatest(constants.RESEND_EVENT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.RESEND_EVENT_REQUEST])
  )
}
